import { createFileRoute } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';
import { getFullName } from '@mews-commander/utils';
import { SpacedDash } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Payment/Plans/$accountId')({
    loader: async ({ params: { accountId }, context: { ensureQueryData, localizeText } }) => {
        const { customers } = await ensureQueryData('accounts', 'getAll', {
            accountIds: [accountId],
        });
        const customer = customers?.[0];

        return {
            title: () =>
                `${getFullName(customer)}${SpacedDash}${localizeText({ textKey: TextKey.PaymentPlanPlural })}`.trim(),
        };
    },
    staticData: {
        owner: MewsTeam.PaymentExperience,
        type: RouteType.Frontend,
    },
});
